import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_INSTANCE } from 'src/features/utils';
import { WhiteLabelConfig } from '../types';

export const fetchWhiteLabelConfig = createAsyncThunk<WhiteLabelConfig, void>(
  'whiteLabel/fetchConfig',
  async () => {
    const response = await API_INSTANCE.get<WhiteLabelConfig>('/api/v1/auth/whitelabel-config');
    return response.data;
  },
);
